import { Box, Grid2, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import { ReactComponent as MentorIcon } from "Assets/Icons/Home/MentorIcon.svg";
import { ReactComponent as ProblemSolvedIcon } from "Assets/Icons/Curriculum/ProblemSolvedIcon.svg";
import { ReactComponent as LeaderBoard } from "Assets/Icons/Drawer/LeaderBoard.svg";
import { ReactComponent as ScoreIcon } from "Assets/Icons/Classroom/ScoreIcon.svg";
import { ReactComponent as LockIcon } from "Assets/Icons/Home/LockIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import PreReadTab from "./ClassDetail/PreReadTab";
import SessionTab from "./ClassDetail/SessionTab";
import AssignmentTab from "./ClassDetail/AssignmentTab";
import HelpTab from "./ClassDetail/HelpTab";
import FeedbackTab from "./ClassDetail/FeedbackTab";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ContestTab from "./ClassDetail/ContestTab";
import { useDispatch, useSelector } from "react-redux";
import { getAssignmentQuestions, getAdditionalProblems } from "Slices/thunks";


const styles = (theme) => ({
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "25px",
});

const ClassDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id = 0, sessionId = 0, tab } = useParams();
  const [currentTab, setCurrentTab] = useState("pre-read");

  const { Profile, Modules, Questions, Translation } = useSelector((state) => ({
    Profile: state.Profile.profile,
    Modules: state.Course.modules,
    Questions: state.Assignment.questions || [],
    Translation: state.Translation.translation?.Course || {},
  }));

  const handleTabChange = (value) => {
    // const segments = location.pathname.split('/');
    // segments[segments.length - 1] = value; 
    // navigate(segments.join('/'));
    navigate(`/session/${id}/${sessionId}/${value}`);
    setCurrentTab(value);
  }
    
  useEffect(() => {
    if (tab) {
      setCurrentTab(tab);
    }
  }, [tab]);


  const sessionID = Modules?.[id]?.Sessions?.[sessionId]?.ID;
  useEffect(() => {
    if (!sessionID) return;

    dispatch(getAssignmentQuestions({ SessionID: sessionID }));
    dispatch(getAdditionalProblems({ SessionID: sessionID }));
  }, [sessionID]);

  // useEffect(() => {
  //   if (Array.isArray(Modules) && sessionId !== undefined) {
  //     const session = Modules[id]?.Sessions[sessionId]
  //     dispatch(getAssignmentQuestions({SessionID: session?.ID}));
  //     dispatch(getAdditionalProblems({SessionID: session?.ID}));
  //   }
  // }, [Modules, sessionId])


  const classTabs = useMemo(() => {
    return [
      {
        label: `${Translation?.PreRead} 0%`,
        url: "pre-read",
      },
      {
        label: `${Translation?.Session} ${((Modules[id]?.Sessions?.reduce((acc, session) => {
          if (session.UserIDs?.includes(Profile.UserId)) {
            acc = acc + 1;
          }
          return acc;
        }, 0) / Modules[id]?.Sessions?.length) * 100 || 0).toFixed(2)} %`,
        url: "session",
      },
      {
        label: `${Translation?.Assignment} ${Modules[id]?.Sessions[sessionId]?.SolvedQuestions || 0}/${Modules[id]?.Sessions[sessionId]?.NoOfQuestions || 0}`,
        url: "assignments",
      },
      {
        label: `${Translation?.AdditionalProblem} ${Modules[id]?.Sessions[sessionId]?.SolvedProblems || 0}/${Modules[id]?.Sessions[sessionId]?.NoOfProblems || 0}`,
        url: "problems",
      },
      {
        label: Translation?.HelpRequest,
        url: "help",
      },
      {
        label: Translation?.Feedback,
        url: "feedback",
      },
    ]
  }, [id, sessionId, Translation, Modules])

  // const quickStats = {
  //   contest: {
  //     first: {
  //       value: "- - -",
  //       name: "View Leaderboard",
  //       icon: LeaderBoard,
  //     },
  //     second: {
  //       value: "- - -/100",
  //       name: "Score Obtained",
  //       icon: ScoreIcon,
  //     },
  //   },
  //   other: {
  //     first: {
  //       value: `${((Modules[id]?.Sessions?.reduce((acc, session) => {
  //         if (session.UserIDs?.includes(Profile.UserId)) {
  //           acc = acc + 1;
  //         }
  //         return acc;
  //       }, 0) / Modules[id]?.Sessions?.length) * 100 || 0).toFixed(2)} %`,
  //       name: "Class Attendance",
  //       icon: MentorIcon,
  //     },
  //     second: {
  //       value: `${Questions?.reduce((acc, question) => question.IsSelectedOptionCorrect ? acc = acc + 1 : acc, 0)}/${Questions.length}`,
  //       name: "Problem Solved",
  //       icon: ProblemSolvedIcon,
  //     },
  //   },
  // };

  // const selectedStat = quickStats[tab === 'contest' ? 'contest' : "other"];

  const selectedStat = useMemo(() => {
    const quickStats = {
    contest: {
      first: {
        value: "- - -",
        name: "View Leaderboard",
        icon: LeaderBoard,
      },
      second: {
        value: "- - -/100",
        name: "Score Obtained",
        icon: ScoreIcon,
      },
    },
    other: [
      {
        value: `${((Modules[id]?.Sessions?.reduce((acc, session) => {
          if (session.UserIDs?.includes(Profile.UserId)) {
            acc = acc + 1;
          }
          return acc;
        }, 0) / Modules[id]?.Sessions?.length) * 100 || 0).toFixed(2)} %`,
        name: "ClassAttendance",
        icon: MentorIcon,
        background: "#FFF7E8"
      },
      {
        value: `${Questions?.reduce((acc, question) => question.IsSelectedOptionCorrect ? acc = acc + 1 : acc, 0)}/${Questions.length}`,
        name: "ProblemSolved",
        icon: ProblemSolvedIcon,
        background: "#F1EDFF"
      },
    ]
    // other: {
    //   first: {
    //     value: `${((Modules[id]?.Sessions?.reduce((acc, session) => {
    //       if (session.UserIDs?.includes(Profile.UserId)) {
    //         acc = acc + 1;
    //       }
    //       return acc;
    //     }, 0) / Modules[id]?.Sessions?.length) * 100 || 0).toFixed(2)} %`,
    //     name: "ClassAttendance",
    //     icon: MentorIcon,
    //     background: "#FFF7E8"
    //   },
    //   second: {
    //     value: `${Questions?.reduce((acc, question) => question.IsSelectedOptionCorrect ? acc = acc + 1 : acc, 0)}/${Questions.length}`,
    //     name: "ProblemSolved",
    //     icon: ProblemSolvedIcon,
    //     background: "#F1EDFF"
    //   },
    // },
  };

  return quickStats[tab === 'contest' ? 'contest' : "other"] || {};

  }, [Modules, Questions])

  return (
    <>
      <Grid2 sx={styles}>
        <Box display={"flex"} gap="16px">
          {selectedStat?.map((stat) => {
            return (
              <Box
                padding="8px 16px"
                display={"flex"}
                flexDirection={"column"}
                gap="5px"
                justifyContent={"space-between"}
                sx={{ background: stat.background, borderRadius: "8px" }}
              >
                <Box display={"flex"} alignItems={"center"} gap="10px">
                  <PrimaryIcon
                    icon={stat.icon}
                    height="24px"
                    width="24px"
                  />
                  <Typography fontWeight={500} variant="title">
                    {stat.value}
                  </Typography>
                </Box>
                <Typography variant="body2">{Translation[stat?.name]}</Typography>
              </Box>
            )
          })}
          {/* <Box
            padding="8px 16px"
            display={"flex"}
            flexDirection={"column"}
            gap="5px"
            justifyContent={"space-between"}
            sx={{ background: "#FFF7E8", borderRadius: "8px" }}
          >
            <Box display={"flex"} alignItems={"center"} gap="10px">
              <PrimaryIcon
                icon={selectedStat?.first?.icon}
                height="24px"
                width="24px"
              />
              <Typography fontWeight={500} variant="title">
                {selectedStat?.first?.value}
              </Typography>
            </Box>
            <Typography variant="body2">{selectedStat?.first?.name}</Typography>
          </Box>
          <Box
            padding="8px 16px"
            sx={{ background: "#F1EDFF", borderRadius: "8px" }}
            display={"flex"}
            flexDirection={"column"}
            gap="5px"
            justifyContent={"space-between"}
          >
            {" "}
            <Box display={"flex"} alignItems={"center"} gap="10px">
              <PrimaryIcon
                icon={selectedStat?.second?.icon}
                height="24px"
                width="24px"
              />
              <Typography fontWeight={500} variant="title">
                {selectedStat?.second?.value}
              </Typography>
            </Box>
            <Typography variant="body2">
              {selectedStat?.second?.name}
            </Typography>
          </Box> */}
        </Box>
        <Tabs
          type="button"
          value={currentTab}
          TabIndicatorProps={{ hidden: true }}
          sx={{ marginBottom: "0px" }}
          onChange={(e, value) => handleTabChange(value)}
        >
          {tab == "contest" ? (
            <Tab
              value={"contest"}
              key={`tab_contest`}
              label={
                <Box display={"flex"} alignItems={"center"} gap={"20px"}>
                  {" "}
                  {Translation?.Contest}{" "}
                  <PrimaryIcon
                    height={"18px"}
                    color={currentTab == "contest" && "white"}
                    width={"18px"}
                    icon={LockIcon}
                  />{" "}
                </Box>
              }
            />
          ) : (
            classTabs?.map((tab, i) => {
              return (
                <Tab value={tab?.url} key={`tab${i}`} label={tab.label} />
              );
            })
          )}
        </Tabs>
        {currentTab == "pre-read" ? (
          <PreReadTab />
        ) : currentTab == "session" ? (
          <SessionTab session={Array.isArray(Modules) ? Modules[id]?.Sessions[sessionId] : {}} />
        ) : currentTab == "assignments" ? (
          <AssignmentTab setCurrentTab={setCurrentTab} />
        ) : currentTab == "problems" ? (
          <AssignmentTab setCurrentTab={setCurrentTab} />
        ) : currentTab == "help" ? (
          <HelpTab />
        ) : currentTab == "contest" ? (
          <ContestTab />
        ) : (
          <FeedbackTab session={Array.isArray(Modules) ? Modules[id]?.Sessions[sessionId] : {}} />
        )}
      </Grid2>
    </>
  );
};

export default ClassDetail;
